import React, { useEffect, useState } from "react";
import { getAllSongsWithout } from ".";
import { isAuthenticated } from "../../Auth/helper";
import Header from "../../User/helper/Header";
import LoggedInNavbar from "./loggedInNavbar";
import { useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import AOS from "aos";
import "aos/dist/aos.css";
import CircularProgress from "@mui/material/CircularProgress";
import LoginPrompt from "../../components/LoginPrompt"; 

const SongPlayList = () => {
  const navigate = useNavigate();
  let [products, setAllProducts] = useState([]);
  let [mainCat, setMainCat] = useState([]);
  let [catThumbNail, setCatThumbNail] = useState([]);
  let [loading, setLoading] = useState(true);
  const [showPrompt, setShowPrompt] = useState(false); // NEW

  useEffect(() => { AOS.init({ duration: 1000 }); }, []);

  const checkSignedIn = (id, musicid, item) => {
    const isSignedin = isAuthenticated() && isAuthenticated().token && isAuthenticated().user._id;
    if (isSignedin) {
      navigate(`/songplayer/${id}/${musicid}/?way=${item}`);
    } else {
      setShowPrompt(true); // NEW
    }
  };

  useEffect(() => {
    const fetchdata = async () => {
      setLoading(true);
      try {
        await getAllSongsWithout().then((x) => {
          const getsubCategory = x.map((item) => item.subCategoryId);
          let uniqueObjArray = [...new Map(getsubCategory.map((item) => [item["subCategoryName"], item])).values()];
          setMainCat(uniqueObjArray.map((item) => item.subCategoryName));
          setCatThumbNail(uniqueObjArray.map((item) => item.subCategoryImageCDN));
          setAllProducts(x);
          setLoading(false);
        }).catch(() => setLoading(false));
      } catch { setLoading(false); }
    };
    fetchdata();
  }, []);

  const showCategory = (id) => {
    const isSignedin = isAuthenticated() && isAuthenticated().token && isAuthenticated().user._id;
    if (isSignedin) {
      navigate(`/category/Songs/${id}`);
    } else {
      setShowPrompt(true);
    }
  };

  return (
    <div>
      <LoginPrompt show={showPrompt} onClose={() => setShowPrompt(false)} />

      {isAuthenticated() && isAuthenticated().user._id && isAuthenticated().token
        ? <LoggedInNavbar /> : <Header />}

      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 24px" }}>
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200 }}>
            <CircularProgress color="warning" />
          </div>
        ) : (
          <div className="container" style={{ paddingTop: "80px" }}>
            <h2 style={{ color: "#E34607", lineHeight: "34px", padding: "20px" }}>Songs</h2>
            {mainCat.length === 0 ? (
              <div style={{ textAlign: "center", padding: "60px 20px", color: "#888" }}>
                <p style={{ fontSize: 16 }}>No songs available at the moment.</p>
              </div>
            ) : (
              <>
                <div className="d-flex flex-row flex-nowrap overflow-auto category-scroll">
                  {mainCat.map((item, index) => (
                    <div className="col-sm-3" key={item}
                      style={{ marginLeft: index === 0 ? 24 : 12, marginRight: index === mainCat.length - 1 ? 24 : 12 }}>
                      <center>
                        <div className="card" onClick={() => showCategory(item)} style={{ width: "18rem", cursor: "pointer" }}>
                          <div className="card-body">
                            <h5 className="card-title" style={{ color: "#E34607" }}>{item}</h5>
                            <LazyLoadImage src={catThumbNail[index]} alt={item} height="200" width="200" loading="lazy" />
                          </div>
                        </div>
                      </center>
                    </div>
                  ))}
                </div>
                <br />
                <div className="text-center" style={{ padding: "40px 20px", color: "#666" }}>
                  <i className="fas fa-hand-pointer" style={{ fontSize: "24px", color: "#E34607", marginBottom: "15px" }}></i>
                  <h4 style={{ color: "#E34607", marginBottom: "8px" }}>Select a Category Above</h4>
                  <p style={{ fontSize: "16px", lineHeight: "1.5" }}>
                    Choose from <strong>Krishna</strong>, <strong>Devi Ma</strong>, or other categories to view songs from that collection.
                  </p>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(SongPlayList);